import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { Observable } from 'rxjs';
import { ResponseResult } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class FarmSeasonService {
  constructor(private commonService: CommonService) {}

  getFarmSeasonByYear(
    year: number,
    userId?: number,
  ): Observable<ResponseResult> {
    var url = `farmseason/detail-by-year/${year}`;
    if (userId) {
      url = url + `?userId=${userId}`
    }
    return this.commonService.getAllNoPaging(
      url
    );
  }
  
  getFarmSeasonByYearV2(model:any): Observable<ResponseResult> {
    var url = `farmseason/detail-by-year`;
    return this.commonService.getDataByBody(
      url, model
    );
  }

  getFarmSeasonDetail(id: number): Observable<ResponseResult> {
    return this.commonService.getById(`farmseason/detail/${id}`);
  }

  createFarmSeasonDetail(model: any): Observable<ResponseResult> {
    return this.commonService.createData(`farmseason/create/`, model);
  }

  updateFarmSeasonDetail(model: any): Observable<ResponseResult> {
    return this.commonService.updateData(`farmseason/detail/`, model);
  }

  deleteFarmSeasonDetail(id: number): Observable<ResponseResult> {
    return this.commonService.deleteData(`farmseason/${id}`);
  }
}
